module.exports = __webpack_public_path__ + "static/media/ecopia.1ba27019.svg";